export function timeoutFunction(functionName, duration) {
  let timeoutId;
  new Promise((resolve) => {
    timeoutId = setTimeout(resolve, duration);
  }).then(() => {
    functionName();
  });

  return timeoutId;
}

export function clearTimeoutFunction(timeoutId) {
  clearTimeout(timeoutId);
}
